<script lang="jsx">
import DateConstants from "@/components/VCalendar/DateConstants.js";
import { dayjs } from "@/utils/helpers";

function isSameDay(one, two) {
  return one && two && one.isSame(two, "day");
}

function beforeCurrentMonthYear(current, today) {
  if (current.year() < today.year()) {
    return 1;
  }
  return current.year() === today.year() && current.month() < today.month();
}

function afterCurrentMonthYear(current, today) {
  if (current.year() > today.year()) {
    return 1;
  }
  return current.year() === today.year() && current.month() > today.month();
}

export default {
  name: "DateTBody",
  props: {
    value: {
      type: Object,
      default: () => dayjs()
    },
    selectedValue: [Object, Array]
  },
  inject: ["calendar"],
  //   computed: {
  //     // month() {
  //     //   return dayjs();
  //     // },
  //     tableRows() {

  //       return tableRows;
  //     },
  //   },
  mounted() {
    console.log(this.calendar);
  },
  methods: {
    onCellClick(col) {
      if (col.disabled) {
        return;
      }
      this.calendar.$emit("on-select", col);
    },
    cellRenderProxy({ date, ...rest }) {
      let render = this.calendar.$scopedSlots["day-cell"];
      if (!render) return this.$createElement('span', null, date.date()); // <span>{date.date()}</span>;
      return render({ date, ...rest });
    }
  },
  render(h) {
    let passed = 0;
    let current;
    const dateTable = [];

    const month1 = this.value.date(1);
    //   let lastMonth1 = month1.clone();
    const day = month1.day();
    const lastMonthDiffDay =
      (day + 7 - this.value.localeData().firstDayOfWeek()) % 7;
    const lastMonth1 = month1.subtract(lastMonthDiffDay, "d");
    
    for (let iIndex = 0; iIndex < DateConstants.DATE_ROW_COUNT; iIndex++) {
      for (let jIndex = 0; jIndex < DateConstants.DATE_COL_COUNT; jIndex++) {
        current = lastMonth1;
        if (passed) {
          current = current.add(passed, "d");
        }
        dateTable.push(current);
        passed++;
      }
    }
    const tableHtml = [];
    passed = 0;

    for (let iIndex = 0; iIndex < DateConstants.DATE_ROW_COUNT; iIndex++) {
      // let isCurrentWeek;
      // let weekNumberCell;
      // let isActiveWeek = false;
      const dateCells = [];

      for (let jIndex = 0; jIndex < DateConstants.DATE_COL_COUNT; jIndex++) {
        // let next = null;
        // let last = null;
        current = dateTable[passed];
        if (jIndex < DateConstants.DATE_COL_COUNT - 1) {
          // next = dateTable[passed + 1];
        }
        if (jIndex > 0) {
          // last = dateTable[passed - 1];
        }

        let disabled = this.calendar.isDisabled(current);
        let selected = false;

        const isBeforeCurrentMonthYear = beforeCurrentMonthYear(
          current,
          this.value
        );
        const isAfterCurrentMonthYear = afterCurrentMonthYear(
          current,
          this.value
        );
        if (this.selectedValue && Array.isArray(this.selectedValue)) {
          const rangeValue = this.selectedValue;
          if (!isBeforeCurrentMonthYear && !isAfterCurrentMonthYear) {
            const startValue = rangeValue[0];
            const endValue = rangeValue[1];

            if (startValue) {
              if (isSameDay(current, startValue)) {
                selected = true;
                // isActiveWeek = true;
              }
            }

            if (startValue || endValue) {
              if (isSameDay(current, endValue)) {
                selected = true;
                // isActiveWeek = true;
              } else if (
                (startValue === null || startValue === undefined) &&
                current.isBefore(endValue, "day")
              ) {
                //   cls += ` ${inRangeClass}`;
              } else if (
                (endValue === null || endValue === undefined) &&
                current.isAfter(startValue, "day")
              ) {
                //   cls += ` ${inRangeClass}`;
              } else if (
                current.isAfter(startValue, "day") &&
                current.isBefore(endValue, "day")
              ) {
                //   cls += ` ${inRangeClass}`;
              }
            }
          }
        } else if (isSameDay(current, this.value)) {
          // keyboard change value, highlight works
          //   selected = true;
          //   isActiveWeek = true;
        }

        if (isSameDay(current, this.selectedValue)) {
          selected = true;
          //   cls += ` ${selectedDateClass}`;
        }

        if (isBeforeCurrentMonthYear) {
          //   cls += ` ${lastMonthDayClass}`;
        }

        if (isAfterCurrentMonthYear) {
          //   cls += ` ${nextMonthDayClass}`;
        }

        if (
          current
            .clone()
            .endOf("month")
            .date() === current.date()
        ) {
          //   cls += ` ${lastDayOfMonthClass}`;
        }

        // if(disabledDate){
        //     if(disabledDate()){}
        // }

        if (selected) {
          // cls += ` ${selectedClass}`;
        }

        // dateCells.push(
        //   <div
        //     class="table-cell"
        //     key={jIndex}
        //     vOn:click={this.onCellClick.bind(this, {
        //       date: current,
        //       selected,
        //       disabled
        //     })}
        //   >
        //     {this.cellRenderProxy({ date: current, selected, disabled })}
        //   </div>
        // );

        dateCells.push(h('div', {
          class: 'table-cell',
          key: jIndex,
          on: {
            click: this.onCellClick.bind(this, {date: current, selected, disabled})
          }
        }, this.cellRenderProxy({ date: current, selected, disabled })))
        passed++;
      }

      // tableHtml.push(
      //   <div class="table-row" key={iIndex}>
      //     {dateCells}
      //   </div>
      // );
      tableHtml.push(h('div', {class: 'table-row', key: iIndex }, dateCells ))
    }
    // console.log(tableHtml)
    return h('div', {class: 'table-row-group'}, tableHtml) //<div class="table-row-group">{tableHtml}</div>;
  }
};
</script>
<style lang="">

</style>
